var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuggestedActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    stroke: "#929292",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4.40039H17.625C18.1223 4.40039 18.5992 4.60057 18.9508 4.95689C19.3025 5.31321 19.5 5.79648 19.5 6.30039V19.6004C19.5 20.1043 19.3025 20.5876 18.9508 20.9439C18.5992 21.3002 18.1223 21.5004 17.625 21.5004H6.375C5.87772 21.5004 5.40081 21.3002 5.04917 20.9439C4.69754 20.5876 4.5 20.1043 4.5 19.6004V6.30039C4.5 5.79648 4.69754 5.31321 5.04917 4.95689C5.40081 4.60057 5.87772 4.40039 6.375 4.40039H8.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 12.4746L11.3149 13.6804C11.4315 13.7985 11.6241 13.7921 11.7326 13.6665L14.8125 10.0996",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 2.5H9.1875C8.66973 2.5 8.25 2.92533 8.25 3.45V5.35C8.25 5.87467 8.66973 6.3 9.1875 6.3H14.8125C15.3303 6.3 15.75 5.87467 15.75 5.35V3.45C15.75 2.92533 15.3303 2.5 14.8125 2.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestedActions);
export default __webpack_public_path__ + "static/media/suggested-actions.5752509380b752c7e13266485332aa68.svg";
export { ForwardRef as ReactComponent };